(function(){
  function start(){
    var band=document.querySelector('[data-kidis-breadcrumb-band]');if(!band)return;
    var selectors='.shopify-section-group-header-group,.header-section,.header-wrapper,.site-header,.site-header__element--sub,.km-host';
    var frame=0;
    function update(){
      frame=0;if(window.scrollY>2)return;
      var current=parseFloat(getComputedStyle(band).marginTop)||0;
      var top=band.getBoundingClientRect().top-current;
      var bottom=0;
      document.querySelectorAll(selectors).forEach(function(el){
        if(el.contains(band))return;
        var r=el.getBoundingClientRect(),style=getComputedStyle(el);
        if(r.width&&r.height&&style.display!=='none'&&style.visibility!=='hidden')bottom=Math.max(bottom,r.bottom);
      });
      var clearance=Math.max(0,Math.ceil(bottom-top));
      if(Math.abs(clearance-current)>0.5)band.style.setProperty('--kidis-header-clearance',clearance+'px');
    }
    function schedule(){if(!frame)frame=requestAnimationFrame(update);}
    if(window.ResizeObserver){var observer=new ResizeObserver(schedule);document.querySelectorAll(selectors).forEach(function(el){if(!el.contains(band))observer.observe(el);});}
    if(window.MutationObserver){var mutation=new MutationObserver(schedule);document.querySelectorAll('.header-section,.header-wrapper,.site-header').forEach(function(el){mutation.observe(el,{attributes:true,attributeFilter:['class','style']});});}
    window.addEventListener('resize',schedule);window.addEventListener('scroll',schedule,{passive:true});window.addEventListener('load',schedule);
    document.addEventListener('shopify:section:load',schedule);document.addEventListener('kidis:product-changed',schedule);
    if(document.fonts&&document.fonts.ready)document.fonts.ready.then(schedule);
    schedule();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
})();
